module.exports = __webpack_public_path__ + "img/addbot.2187d00b.png";